export function imageError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.isOK = false
}

export function setPath(state,payload){
    state.path = payload.data.path
}